<div class="settings-wrapper">
  <div class="tabs">
    <div class="tab" [class.active]="activeTab === 'employee'" (click)="setTab('employee')">
      Employee New Joinee Workflow Screen Config
    </div>
    <div class="tab" [class.active]="activeTab === 'admin'" (click)="setTab('admin')">
      Admin New Joinee Workflow Screen Config
    </div>
    <div class="tab" [class.active]="activeTab === 'form11'" (click)="setTab('form11')">PDF Form Config</div>
  </div>

  <div class="tabs-content">
    <app-employee-newjoinee-wf-screen-config
      *ngIf="activeTab === 'employee'"
      (completed)="goToNextTab()"></app-employee-newjoinee-wf-screen-config>
    <app-admin-newjoinee-wf-screen-config
      *ngIf="activeTab === 'admin'"
      (completed)="goToNextTab()"></app-admin-newjoinee-wf-screen-config>
    <app-form11-pdf-screen-config *ngIf="activeTab === 'form11'"></app-form11-pdf-screen-config>
  </div>
</div>
